import { render, staticRenderFns } from "./Ant-tabel.vue?vue&type=template&id=645e71b4&scoped=true&"
import script from "./Ant-tabel.vue?vue&type=script&lang=js&"
export * from "./Ant-tabel.vue?vue&type=script&lang=js&"
import style0 from "./Ant-tabel.vue?vue&type=style&index=0&id=645e71b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645e71b4",
  null
  
)

export default component.exports